import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import { theme as themes } from '@clearscore/constants.score-bands';

import { NO_FILE } from '../dashboard.constants';

const getScore = (state) => resolveProp('dashboard.data.creditReportInfo.score', state) || 0;
const getScoreMax = (state) => resolveProp('dashboard.data.creditReportInfo.scoreMaxValue', state);
const getScoreBand = (state) => resolveProp('dashboard.data.creditReportInfo.scoreBand', state);
const getTheme = (state) => {
    const accountIdvStatus = resolveProp('dashboard.data.accountIDVStatus', state);
    const scoreBand = resolveProp('dashboard.data.creditReportInfo.scoreBand', state);
    const scoreBandWithNoFile = accountIdvStatus === NO_FILE ? '5' : scoreBand;
    return themes(scoreBandWithNoFile);
};

export default createSelector(getScore, getScoreMax, getScoreBand, getTheme, (score, scoreMax, scoreBand, theme) => ({
    score,
    scoreMax,
    scoreBand,
    theme,
}));
